// extracted by css-extract-rspack-plugin
export default {"okButton":"okButton-RpHxwF"};